import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The type-scale steps declared in src/styles.css (NO-753), as bare step names.
// Keep them bare: a prefixed class string in a file under src would be picked
// up by every consumer's Tailwind scan and emitted into its CSS.
export const TYPE_SCALE_STEPS = [
  "micro",
  "eyebrow",
  "caption",
  "meta",
  "label",
  "body-sm",
  "body",
  "body-lg",
  "reading",
  "title-sm",
  "title",
  "heading-sm",
  "heading",
  "display",
] as const;

export const LEADING_STEPS = ["title", "compact", "body", "reading"] as const;

// Registers the steps so tailwind-merge treats a step as a font size (or a
// line height), not a text color: it then replaces another size and keeps a
// color next to it.
const twMergeNdd = extendTailwindMerge({
  extend: {
    theme: {
      text: [...TYPE_SCALE_STEPS],
      leading: [...LEADING_STEPS],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMergeNdd(clsx(inputs));
}
